import { CART_RECEIVE, CART_SHOW_INFO, CART_SET_PRICEREQUEST_RESPONSE } from '../constants';
const initialState = {
    quantity: 0,
    orderTotal: 0,
    showInfo: false,
    priceRequestResponse: {
        message: '',
        articleNumber: null,
    },
    checkoutUrl: '',
    orderRows: [],
    discountRows: [],
    discount: '',
    deliveryCost: '',
    paymentCost: '',
    grandTotal: '',
    vat: '',
    hasQuotationProduct: false,
    hasCustomPricesPersmission: false,
    systemId: ''
};
export const cart = (state = initialState, action) => {
    switch (action.type) {
        case CART_RECEIVE:
        case CART_SHOW_INFO:
            return {
                ...state,
                ...action.payload,
            };
        case CART_SET_PRICEREQUEST_RESPONSE:
            return {
                ...state,
                priceRequestResponse: {
                    message: action.payload.message,
                    articleNumber: action.payload.articleNumber,
                },
            };
        default:
            return state;
    }
};
